import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSlackwareComponent } from './simple-icons-slackware.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSlackwareComponent ],
    exports:      [ SimpleIconsSlackwareComponent ],
    bootstrap:    []
})
export class SimpleIconsSlackwareModule {}
